export default __webpack_public_path__ + "static/media/mrc-google-play-badge.7f9c8224.png";